<template>
  <div class="wrapper">
    <section class="image-container">
      <img src="../assets/images/brygga.jpg" />
      <div class="image-container__text">
        11 juli <span class="image-container__hyphen">-</span> 2026
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Hero",
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 80px;
  box-shadow: 1px 1px 8px #c8c8c8;
}
.image-container {
  width: 100%;
  overflow: hidden;
  height: 400px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #f6ff71;
    text-transform: uppercase;
    letter-spacing: 2vw;
    font-size: 3vw;
    text-shadow: 0px 0px 10px #ffffff;
  }

  @media only screen and (max-width: 600px) {
    height: 200px;

    &__text {
      font-size: 10vw;
    }

    &__hyphen {
      display: none;
    }
  }
}
</style>
